import { createContext, useContext } from 'react';

export interface Customer {
  id: string;
  name: string;
  email: string;
}

export interface AuthState {
  authenticated: boolean;
  loading: boolean;
  customer: Customer | null;
  error: string | null;
}

export interface AuthContextValue extends AuthState {
  logout: () => Promise<void>;
  checkSession: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
